function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M18,6.31a.36.36,0,0,0-.11-.16l-6-6A.36.36,0,0,0,11.69,0a.41.41,0,0,0-.19,0h-8A.5.5,0,0,0,3,.5V3H.5a.5.5,0,0,0-.5.5v20a.5.5,0,0,0,.5.5h14a.5.5,0,0,0,.5-.5V21h2.5a.5.5,0,0,0,.5-.5V6.5A.41.41,0,0,0,18,6.31Zm-6-4.6L16.29,6H12ZM14,23H1V4H3V20.5a.5.5,0,0,0,.5.5H14ZM4,20V1h7V6.5a.5.5,0,0,0,.5.5H17V20Z"
})));

var SvgClipboard = function SvgClipboard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 18 24",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClipboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clipboard.9d05603c.svg";
export { ForwardRef as ReactComponent };